<template>
  <v-flex class="producto" d-flex>
    <v-card>
      <v-card-media
        :src="producto.urlImg"
        height="100px"
        contain
        v-on:click="cambiarCantidad(1)"
        v-on:click.right.prevent="cambiarCantidad(-1)"
        >
        <v-container
          fill-height
          fluid
          pa-2
          >
          <v-layout fill-height>
            <v-flex xs12 align-end flexbox>
              <span class="headline white--text" v-text=""></span>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-media>
      <v-card-title primary-title>
        <div>
          <h3 class="headline mb-0">{{ producto.nombre }}</h3>
        </div>
      </v-card-title>
      <v-card-actions>
        <v-chip :color="colorFondo" :text-color="colorTexto">{{ producto.cantidad }}</v-chip>
        <v-spacer></v-spacer>
        <v-btn v-if="!this.disabled" icon small v-on:click="cambiarCantidad(1)">
          <v-icon>add_circle</v-icon>
        </v-btn>
        <v-btn v-if="!this.disabled" icon small v-on:click="cambiarCantidad(-1)">
          <v-icon>remove_circle</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <v-chip :color="colorFondo" :text-color="colorTexto">{{ producto.moneda }}{{ total | formatoNumero }}</v-chip>
      </v-card-actions>
    </v-card>
  </v-flex>
</template>

<script>
export default {
  name: 'venta-producto',
  props: {
    producto: {
      nombre: '',
      precio: 0,
      cantidad: 0,
      total: 0,
      urlImg: ''
    },
    disabled: false
  },
  data: () => ({
    actualizarComputed: 0
  }),
  filters: {
    formatoNumero (value) {
      return new Intl.NumberFormat('es-PE', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(value)
    }
  },
  computed: {
    colorFondo () {
      this.actualizarComputed = 0
      return this.producto.cantidad + this.actualizarComputed > 0 ? 'primary' : ''
    },
    colorTexto () {
      this.actualizarComputed = 0
      return this.producto.cantidad + this.actualizarComputed > 0 ? 'white' : ''
    },
    total () {
      this.actualizarComputed = 0
      return this.producto.cantidad + this.actualizarComputed > 0 ? this.producto.total : this.producto.precio
    }
  },
  methods: {
    cambiarCantidad (diferencia) {
      if (!this.disabled && this.producto.cantidad + diferencia >= 0) {
        this.producto.cantidad += diferencia
        this.producto.total = this.producto.cantidad * this.producto.precio
        this.actualizarComputed = 1
        this.$forceUpdate()
        this.$emit('cambio-total')
      }
    }
  }
}
</script>

<style>
  .headline {
    font-size: 13px!important;
    font-weight: 600;
  }
  .v-card__title {
    padding-left: 16px;
  }
  .producto {
    max-width: 205px;
  }
</style>



// WEBPACK FOOTER //
// src/components/VentaProducto.vue